import ApiEndpointConstants from '../constants/api/ApiEndpointConstants';
import CookieUtil from '../utils/CookieUtil';
import LocalStorageUtil from '../utils/LocalStorageUtil';
import api from './API';

export const submitDriveOrder = (data) => {
    const tgid = CookieUtil.loadTelegramId();
    const amount = CookieUtil.loadPaymentAmount() || 300;
    const amount_fast = CookieUtil.loadPaymentAmountFast() || 1050;
    let stusername = LocalStorageUtil.loadSTUsername();
    if (!stusername) {
        stusername = 'admin';
    }
    const newData = Object.assign({}, data, {tgid, amount, amount_fast, stusername});
    return api.post(
        `${ApiEndpointConstants.ORDER}`,
        { data: JSON.stringify(newData) },
    );
}

export const updateDriveOrder = (data) => {
    const tgid = CookieUtil.loadTelegramId();
    const newData = Object.assign({}, data, {tgid});
    return api.post(
        `${ApiEndpointConstants.ORDER_UPDATE}`,
        { data: JSON.stringify(newData) },
    );
}

export const updateOrderStatus = (params) => {
    return api.post(
        `${ApiEndpointConstants.ORDER_STATUS_UPDATE}`,
        params,
    );
}

export const updateOrderShareStatus = (params) => {
    return api.post(
        `${ApiEndpointConstants.ORDER_SHARE_STATUS}`,
        params,
    );
}

export const getOrderDetailByOrderNo = (orderNo) => {
    return api.post(
        `${ApiEndpointConstants.ORDER_DETAIL}`,
        {orderNo},
    );
}
